// src/utils/models/switchSupplierModel.js

export const createSwitchSupplier = (data) => ({
  id: data.id || null,  // CAMBIADO: null en lugar de ''
  name: data.name || '',
  web: data.web || '',
  isActive: data.isActive !== undefined ? data.isActive : true,
  createdAt: data.createdAt || new Date().toISOString(),
  updatedAt: data.updatedAt || new Date().toISOString(),
});

export const switchSupplierSchema = {
  name: '',
  web: '',
  isActive: true,
};